module.exports = __webpack_public_path__ + "img/aguahuixquilucan_ANT.7f98d920.jpg";